/* eslint-disable max-len */
/* eslint-disable no-console */

import { warningMarkerData } from '../../shared/constantVariable';

function jsontocsvConvertion(props, dssro_data, translateObject) {
  const {
    stream_output,
    coverpage_dict,
    feed_product_waste_summary,
    system_units,
    cf_summary,
    pump_summary,
    argo_summary,
    erd_summary,
    mixer_summary,
    stripper_summary,
    clro_elem_summary,
    clro_overview,
    chem_dose_summary,
    edi_summary,
    ro_elem_summary,
    ro_summary,
    ro_hp,
    errors,
    pdfoption,
    ediOutputData
  } = props;
  const dataArray = [
    { key: 'Ca++', key1: 'Ca++', key2: 'Ca++', key3: 'ppm_dict' },
    { key: 'Mg++', key1: 'Mg++', key2: 'Mg++', key3: 'ppm_dict' },
    { key: 'Na+', key1: 'Na+', key2: 'Na+', key3: 'ppm_dict' },
    { key: 'K+', key1: 'K+', key2: 'K+', key3: 'ppm_dict' },
    { key: 'NH4+', key1: 'NH4+', key2: 'NH4+', key3: 'ppm_dict' },
    { key: 'Ba++', key1: 'Ba++', key2: 'Ba++', key3: 'ppm_dict' },
    { key: 'Sr++', key1: 'Sr++', key2: 'Sr++', key3: 'ppm_dict' },
    { key: 'Fe++', key1: 'Fe++', key2: 'Fe++', key3: 'ppm_dict' },
    { key: 'Mn++', key1: 'Mn++', key2: 'Mn++', key3: 'ppm_dict' },
    { key: 'SO4--', key1: 'SO4--', key2: 'SO4--', key3: 'ppm_dict' },
    { key: 'Cl-', key1: 'Cl-', key2: 'Cl-', key3: 'ppm_dict' },
    { key: 'F-', key1: 'F-', key2: 'F-', key3: 'ppm_dict' },
    { key: 'NO3-', key1: 'NO3-', key2: 'NO3-', key3: 'ppm_dict' },
    { key: 'Br-', key1: 'Br-', key2: 'Br-', key3: 'ppm_dict' },
    { key: 'PO4---', key1: 'PO4---', key2: 'PO4---', key3: 'ppm_dict' },
    { key: 'B', key1: 'B-', key2: 'B-', key3: 'ppm_dict' },
    { key: 'SiO2', key1: 'SiO2', key2: 'SiO2', key3: 'ppm_dict' },
    { key: 'H2S', key1: 'H2S', key2: 'H2S', key3: 'ppm_dict' },
    { key: 'HCO3-', key1: 'HCO3-', key2: 'HCO3-', key3: 'ppm_dict' },
    { key: 'CO2', key1: 'CO2', key2: 'CO2', key3: 'ppm_dict' },
    { key: 'CO3--', key1: 'CO3--', key2: 'CO3--', key3: 'ppm_dict' },
    { key: 'TDS', key1: 'feed_tds', key2: 'tds', key3: 'prop_dict' },
    { key: 'pH', key1: 'feed_ph', key2: 'ph', key3: 'prop_dict' },
    { key: `Pi.${system_units.Pressure ? system_units.Pressure : 'bar'}`, key1: 'feed_pi', key2: 'osmotic_pressure', key3: 'sat_indices' },
    { key: 'Conductivity', key1: 'feed_cond', key2: 'conductivity', key3: 'sat_indices' },
    { key: 'Hardness, ppm as CaCO3', key1: 'feed_hardness', key2: 'hardness', key3: 'prop_dict' },
    { key: 'Density, kg/m3', key1: 'feed_density', key2: 'density', key3: 'prop_dict' },
    { key: 'Ionic Str', key1: 'feed_is', key2: 'ionic_str', key3: 'prop_dict' }
  ];
  const { perm_loop_data, conc_loop_data } = Object.keys(dssro_data).length > 0 ? dssro_data[0].output_user : { perm_loop_data: {}, conc_loop_data: {} };
  const newData = pdfoption.reduce((acc, obj) => {
    acc[obj.label] = !!((obj.disabled && obj.checked)); // assign the value to the label in the accumulator
    return acc;
  }, {});
  const addUnitsInMixerSplitter = () => {
    const obj = {};
    Object.keys(mixer_summary[mixer_summary['Mixer-Splitter Unit ID'][0]]).map((ele) => {
      let str = '-';
      if (ele === 'Split Ratios') {
        str = '(user input)';
      } else if (ele === 'Mix Ratios') {
        str = '(calculated)';
      }
      obj[ele] = str;
      return ele;
    });
    mixer_summary.units = obj;
  };

  // using this function we are handling values  ----> Kranthi
  const appendNumberText = (value, floatdecimal) => {
    floatdecimal = floatdecimal || 2;
    if (value === undefined) {
      return '-';
    }

    // If the value is an array (ex: [25, 39, 1]), format each element.
    if (Array.isArray(value)) {
      return value
        .map((v) => {
          if (v == null) return '-';
          if (!Number.isNaN(Number(v))) return Number(v).toFixed(floatdecimal);
          return String(v);
        })
        .join(', ');
    }

    // Avoid split/includes crashes on non-string objects.
    if (value !== null && typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    // Normalize to string for string operations.
    const strValue = String(value);
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      // Handle comma-separated numeric lists like "25, 39, 1"
      if (strValue.includes(',') && /^[0-9,.\s-]+$/.test(strValue)) {
        return strValue
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
          .map((s) => (!Number.isNaN(Number(s)) ? Number(s).toFixed(floatdecimal) : s))
          .join(', ');
      }

      if (strValue.includes(',')) {
        return strValue.replaceAll(',', ' ');
      }
      const split_Val = strValue.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_Val[0])) ? Number(split_Val[0]).toFixed(floatdecimal) : split_Val[0];
        const text_val = split_Val[1];
        return `${num_val} ${text_val}`; // combing text and value ----> Kranthi
      }
      const split_perval = strValue.split('%'); // spliting all the value with % ----> Kranthi
      if (split_perval.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_perval[0])) ? Number(split_perval[0]).toFixed(floatdecimal) : split_perval[0];
        return `${num_val}`; // showing text ----> Kranthi
      }
      return strValue;
    }
    return Number(value).toFixed(floatdecimal);
  };
  // using this function we are handling values  ----> Kranthi
  const appendNumberText2 = (value) => {
    if (value === undefined) {
      return '-';
    }

    // If the value is an array (ex: [25, 39, 1]), format each element.
    if (Array.isArray(value)) {
      return value
        .map((v) => {
          if (v == null) return '-';
          if (!Number.isNaN(Number(v))) return Number(v).toFixed(2);
          return String(v);
        })
        .join(', ');
    }

    // Avoid split/includes crashes on non-string objects.
    if (value !== null && typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }

    const strValue = String(value);
    if (Number.isNaN(Number(value))) { // checking values is number or not ----> Kranthi
      // Handle comma-separated numeric lists like "25, 39, 1"
      if (strValue.includes(',') && /^[0-9,.\s-]+$/.test(strValue)) {
        return strValue
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
          .map((s) => (!Number.isNaN(Number(s)) ? Number(s).toFixed(2) : s))
          .join(', ');
      }

      if (strValue.includes(',')) {
        return strValue.replaceAll(',', ' ');
      }
      const split_Val = strValue.split(' '); // spliting all the value with space ----> Kranthi
      if (split_Val.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const numMatch = strValue.match(/[0-9]*\.?[0-9]+/g);  // extracts number from string
        if (numMatch) {
          const num = numMatch[0];
          if (!Number.isNaN(num)) {
            const formattedNum = Number(num).toFixed(2);  // formats it to 2 dp
            return strValue.replace(num, formattedNum);  // substitutes new formatted number into original string
          }
        }
      }
      const split_perval = strValue.split('%'); // spliting all the value with % ----> Kranthi
      if (split_perval.length > 1) { // checking split value have more that two vlaue  ----> Kranthi
        const num_val = !Number.isNaN(Number(split_perval[0])) ? Number(split_perval[0]).toFixed(2) : split_perval[0];
        return `${num_val}`; // showing text ----> Kranthi
      }
      return strValue;
    }
    return Number(value).toFixed(2);
  };
  const setCLRO_Stream_data = (tableValue, str, arr) => {
    arr.push(
      str === 'stream' ? [] : [str],
      [translateObject('Category'), translateObject('Parameter'), '', ...Object.keys(tableValue)],
      str === 'stream' ? [
        translateObject('Stream Name'),
        '',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].label)
      ] : [],
      [
        translateObject('Ion Concentration'),
        'Ca++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Ca++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Mg++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Mg++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Na+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Na+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'K+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['K+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'NH4+',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['NH4+'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Ba++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Ba++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Sr++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Sr++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Fe++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Fe++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Mn++',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Mn++'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'SO4--',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['SO4--'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Cl-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Cl-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'F-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['F-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'NO3-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['NO3-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'Br-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['Br-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'PO4---',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['PO4---'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'B',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['B-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'SiO2',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.SiO2.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'H2S',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.H2S.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'HCO3-',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['HCO3-'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'CO2',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict.CO2.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'CO3--',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].ppm_dict['CO3--'].toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Ion Concentration'),
        'TDS',
        'mg/L',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return tableValue[d].prop_dict.tds.toFixed(flag.length > 0 ? 5 : 3);
        })
      ],
      [
        translateObject('Stream Property'),
        translateObject('Flow'),
        system_units['Volume Flow'],
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.flow.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Pressure'),
        system_units.Pressure,
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.press.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Temperature'),
        system_units.Temperature,
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.temp.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        'pH',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.ph.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Alkalinity'),
        'ppm CaCO3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.malk.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Conductivity at 25°C'),
        'µS/cm',
        ...Object.keys(tableValue).map((d) => {
          const flag = ediOutputData.filter((edio) => {
            return tableValue[d].label.toLowerCase().indexOf(edio.target) > 0;
          });
          return Number(tableValue[d].sat_indices.conductivity).toFixed(flag.length > 0 ? 4 : 1);
        })
      ],
      [
        translateObject('Stream Property'),
        translateObject('Hardness'),
        'ppm as CaCO3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.hardness.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Density'),
        'kg/m3',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.density.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Ionic Strength'),
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].prop_dict.ionic_str.toFixed(2))
      ],
      [
        translateObject('Stream Property'),
        translateObject('Osm.Pressure'),
        system_units.Pressure,
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.osmotic_pressure.toFixed(2))
      ],
      [
        translateObject('Saturation Data'),
        'BaSO4',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.baso4)
      ],
      [
        translateObject('Saturation Data'),
        'CaF2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.caf2)
      ],
      [
        translateObject('Saturation Data'),
        'Mg(OH)2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.mgoh2)
      ],
      [
        translateObject('Saturation Data'),
        'SiO2',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.sio2)
      ],
      [
        translateObject('Saturation Data'),
        'SrSO4',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.srso4)
      ],
      [
        translateObject('Saturation Data'),
        'Struvite',
        '%',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.struvite)
      ],
      [
        translateObject('Saturation Data'),
        'LSI',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.lsi)
      ],
      [
        translateObject('Saturation Data'),
        'SDSI',
        '',
        ...Object.keys(tableValue).map((d) => tableValue[d].sat_indices.sdi)
      ]
    );
    if (str !== 'stream') {
      arr.push(['']);
      arr.push(['']);
    }
    return arr;
  };
  const createStreamAndDSSROTable = (tableValue, str = 'stream') => {
    const arr = [];
    if (str === 'stream') {
      setCLRO_Stream_data(tableValue, str, arr);
    } else {
      dssro_data.map((ele) => {
        if (str === 'DSSRO Permeate Stream (Loop wise) Summary') {
          return setCLRO_Stream_data(ele.output_user.perm_loop_data, `${ele.output_user.name} Permeate Stream (Loop wise) Summary`, arr);
        }
        return setCLRO_Stream_data(ele.output_user.conc_loop_data, `${ele.output_user.name} Concentrate Stream (Loop wise) Summary`, arr);
      });
    }
    return arr.filter((ele) => ele.length);
  };
  const DSSRO_Permeate_Stream = newData['DSSRO Loop Summary'] && createStreamAndDSSROTable(perm_loop_data, 'DSSRO Permeate Stream (Loop wise) Summary');
  const DSSRO_Concentrate_Stream = newData['DSSRO Loop Summary'] && createStreamAndDSSROTable(conc_loop_data, 'DSSRO Concentrate Stream (Loop wise) Summary');
  const SteamData = newData['Detailed Stream Data'] && createStreamAndDSSROTable(stream_output, 'stream');
  const feed_Preductwaste_Data = newData['Feed-Product-Waste Summary'] && [
    [translateObject('Category'), translateObject('Parameter'), '', ...Object.values(feed_product_waste_summary['Unit ID'])],
    [
      translateObject('Information'),
      translateObject('Water Source'),
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d].Information)
    ],
    [
      translateObject('Ion Concentration'),
      'Ca++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Ca++'].toFixed(4))
    ],
    [
      translateObject('Ion Concentration'),
      'Mg++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Mg++'])
    ],
    [
      translateObject('Ion Concentration'),
      'Na+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Na+'])
    ],
    [
      translateObject('Ion Concentration'),
      'K+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['K+'])
    ],
    [
      translateObject('Ion Concentration'),
      'NH4+',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['NH4+'])
    ],
    [
      translateObject('Ion Concentration'),
      'Ba++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Ba++'])
    ],
    [
      translateObject('Ion Concentration'),
      'Sr++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Sr++'])
    ],
    [
      translateObject('Ion Concentration'),
      'Fe++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Fe++'])
    ],
    [
      translateObject('Ion Concentration'),
      'Mn++',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Mn++'])
    ],
    [
      translateObject('Ion Concentration'),
      'SO4--',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['SO4--'])
    ],
    [
      translateObject('Ion Concentration'),
      'Cl-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Cl-'])
    ],
    [
      translateObject('Ion Concentration'),
      'F-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['F-'])
    ],
    [
      translateObject('Ion Concentration'),
      'NO3-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['NO3-'])
    ],
    [
      translateObject('Ion Concentration'),
      'Br-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['Br-'])
    ],
    [
      translateObject('Ion Concentration'),
      'PO4---',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['PO4---'])
    ],
    [
      translateObject('Ion Concentration'),
      'B',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['B-'])
    ],
    [
      translateObject('Ion Concentration'),
      'SiO2',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].SiO2)
    ],
    [
      translateObject('Ion Concentration'),
      'H2S',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].H2S)
    ],
    [
      translateObject('Ion Concentration'),
      'HCO3-',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['HCO3-'])
    ],
    [
      translateObject('Ion Concentration'),
      'CO2',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].CO2)
    ],
    [
      translateObject('Ion Concentration'),
      'CO3--',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration']['CO3--'])
    ],
    [
      translateObject('Ion Concentration'),
      'TDS',
      'mg/L',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Ion Concentration'].tds)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Flow'),
      system_units['Volume Flow'],
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Flow)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Pressure'),
      system_units.Pressure,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Pressure)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Temperature'),
      system_units.Temperature,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Temperature)
    ],
    [
      translateObject('Stream Property'),
      translateObject('pH'),
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].pH)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Alkalinity'),
      'ppm CaCO3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Alkalinity)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Conductivity at 25°C'),
      'µS/cm',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Conductivity at 25°C'])
    ],
    [
      translateObject('Stream Property'),
      translateObject('Hardness'),
      'ppm as CaCO3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Hardness)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Density'),
      'kg/m3',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property'].Density)
    ],
    [
      translateObject('Stream Property'),
      translateObject('Ionic Strength'),
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Ionic Strength'])
    ],
    [
      translateObject('Stream Property'),
      translateObject('Osm.Pressure'),
      system_units.Pressure,
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Stream Property']['Osm.Pressure'])
    ],
    [
      translateObject('Saturation Data'),
      'BaSO4',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].BaSO4)
    ],
    [
      translateObject('Saturation Data'),
      'CaF2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].CaF2)
    ],
    [
      translateObject('Saturation Data'),
      'Mg(OH)2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data']['Mg(OH)2'])
    ],
    [
      translateObject('Saturation Data'),
      'SiO2',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SiO2)
    ],
    [
      translateObject('Saturation Data'),
      'SrSO4',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SrSO4)
    ],
    [
      translateObject('Saturation Data'),
      'Struvite',
      '%',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].Struvite)
    ],
    [
      translateObject('Saturation Data'),
      'LSI',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].LSI)
    ],
    [
      translateObject('Saturation Data'),
      'SDSI',
      '',
      ...Object.values(feed_product_waste_summary['Unit ID']).map((d) => feed_product_waste_summary[d]['Saturation Data'].SDSI)
    ]
  ];
  const CF_Params = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Feed Temperature', KeyText: translateObject('Feed Temperature') },
    { Key: 'Flow Capacity', KeyText: translateObject('Flow Capacity') },
    { Key: 'Filter Type', KeyText: translateObject('Filter Type') },
    { Key: 'Number of Filters', KeyText: translateObject('Number of Filters') },
    { Key: 'Design Flow Per TIE', KeyText: translateObject('Design Flow Per TIE') },
    { Key: 'Actual Flow per TIE', KeyText: translateObject('Actual Flow per TIE') },
    { Key: 'Inlet Pressure', KeyText: translateObject('Inlet Pressure') },
    { Key: 'Outlet Pressure', KeyText: translateObject('Outlet Pressure') },
    { Key: 'Pressure Drop', KeyText: translateObject('Pressure Drop') },
  ];
  const Pumps_Params = [
    { Key: 'RO Unit Attached', KeyText: translateObject('RO/NF Unit Attached') },
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Feed Temperature', KeyText: translateObject('Feed Temperature') },
    { Key: 'Flow Rate', KeyText: translateObject('Flow Rate') },
    { Key: 'Inlet Pressure', KeyText: translateObject('Inlet Pressure') },
    { Key: 'Discharge Pressure', KeyText: translateObject('Discharge Pressure') },
    { Key: 'Power Consumption', KeyText: translateObject('Power Consumption') },
    { Key: 'Combined Efficiency', KeyText: translateObject('Combined Efficiency') },
    { Key: 'Pump Efficiency', KeyText: translateObject('Pump Efficiency') },
    { Key: 'Motor Efficiency', KeyText: translateObject('Motor Efficiency') },
    { Key: 'VFD Efficiency', KeyText: translateObject('VFD Efficiency') },
  ];
  const ERD_key_value = [
    { Key: 'ERD Type', KeyText: translateObject('ERD Type') },
    { Key: 'RO Unit Attached', KeyText: translateObject('RO/NF Unit Attached') },
    { Key: 'Installed Location', KeyText: translateObject('Installed Location') },
    { Key: 'LP Discharge Pressure', KeyText: translateObject('LP Discharge Pressure') },
    { Key: 'Net Transfer Efficiency', KeyText: translateObject('Net Transfer Efficiency') },
    { Key: 'Boost Pressure', KeyText: translateObject('Boost Pressure') },
    {
      Key: 'Leakage (Reject in HP OUT)',
      KeyText: translateObject('Leakage (Reject in HP OUT)'),
    },
    { Key: 'Mixing at Membrane Feed', KeyText: translateObject('Mixing at Membrane Feed') },
    { Key: 'Total Power Consumption', KeyText: translateObject('Total Power Consumption') },
    { Key: 'HP Pump', KeyText: translateObject('HP Pump') },
    { Key: 'Circulation Pump', KeyText: translateObject('Circulation Pump') },
    { Key: 'Energy Recovered', KeyText: translateObject('Energy Recovered') },
    { Key: 'Power Saving', KeyText: translateObject('Power Saving') },
  ];
  const Mixer_Splitter_Params = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Inlet Stream ID', KeyText: translateObject('Inlet Stream ID') },
    { Key: 'Outlet Stream ID', KeyText: translateObject('Outlet Stream ID') },
    { Key: 'Mode', KeyText: translateObject('Mode') },
    { Key: 'Mix Ratios', KeyText: translateObject('Mix Ratios') },
    { Key: 'Split Ratios', KeyText: translateObject('Split Ratios') },
  ];
  const stripper_values_keys = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Feed Temperature', KeyText: translateObject('Feed Temperature') },
    { Key: 'Flow Capacity', KeyText: translateObject('Flow Capacity') },
    { Key: 'Outlet CO2 Concentration', KeyText: translateObject('Outlet CO2 Concentration') },
    { Key: 'Outlet H2S Concentration', KeyText: translateObject('Outlet H2S Concentration') },
    { Key: 'Outlet NH3 Concentration', KeyText: translateObject('Outlet NH3 Concentration') },
  ];
  const chemical_dose_para = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Chemical', KeyText: translateObject('Chemical') },
    { Key: 'Supplied Form', KeyText: translateObject('Supplied Form') },
    { Key: 'Dosing Endpoint', KeyText: translateObject('Dosing Endpoint') },
    { Key: 'Target Value', KeyText: translateObject('Target Value') },
    { Key: 'Dosage Rate', KeyText: translateObject('Dosage Rate') },
    { Key: 'Mass Flow Rate', KeyText: translateObject('Mass Flow Rate') },
    { Key: 'Concentration as Metered', KeyText: translateObject('Concentration as Metered') },
    {
      Key: 'Specific Gravity as Metered',
      KeyText: translateObject('Specific Gravity as Metered'),
    },
    { Key: 'Metered Flow Rate', KeyText: translateObject('Metered Flow Rate') },
    { Key: 'Avg Cons.As Metered', KeyText: translateObject('Avg Cons.As Metered') },
    { Key: 'Avg Cons.As Supplied', KeyText: translateObject('Avg Cons.As Supplied') },
    {
      Key: 'Avg Cons.As Supplied with SF',
      KeyText: translateObject('Avg Cons.As Supplied with SF'),
    },
  ];
  const chemical_dose_supplied_para = [
    { KeyText: translateObject('Chemical Dosing Unit ID'), Key: 'Chemical Dosing Unit ID' },
    { KeyText: translateObject('Chemical'), Key: 'Chemical' },
    { KeyText: translateObject('Supplied Form'), Key: 'Supplied Form' },
    { KeyText: translateObject('Concentration as Supplied'), Key: 'Concentration as Supplied' },
    {
      KeyText: translateObject('Specific Gravity as Supplied'),
      Key: 'Specific Gravity as Supplied',
    },
    { KeyText: translateObject('Total Consumption'), Key: 'Total Consumption' },
    { KeyText: translateObject('Mass Flow Rate'), Key: 'Tot.Cons Mass Flow Rate' },
    { KeyText: translateObject('As Supplied'), Key: 'Tot.Cons As Supplied' },
    { KeyText: translateObject('As Supplied with SF'), Key: 'Tot.Cons As Supplied with SF' },
  ];
  const EDI_Params = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Feed Flow', KeyText: translateObject('Feed Flow') },
    { Key: 'Product Flow', KeyText: translateObject('System Product Flow Rate') },
    { Key: 'Concentrate Flow', KeyText: translateObject('Concentrate Flow') },
    { Key: 'Electrode Bleed Flow', KeyText: translateObject('Electrode Bleed Flow') },
    { Key: 'EDI Unit Recovery', KeyText: translateObject('EDI Unit Recovery') },
    { Key: 'Number of E-Cell EDI Stack', KeyText: translateObject('No. of E-Cell EDI Stacks') },
    { Key: 'Feed Temperature', KeyText: translateObject('Feed Temperature') },
    { Key: 'Feed Pressure', KeyText: translateObject('Feed Pressure') },
    { Key: 'Concentrate Pressure', KeyText: translateObject('Concentrate Pressure') },
    { Key: 'Product Outlet Pressure', KeyText: translateObject('Product Outlet Pressure') },
    { Key: 'Current', KeyText: translateObject('Current') },
    { Key: 'Voltage', KeyText: translateObject('Voltage') },
    { Key: 'AC Power', KeyText: translateObject('AC Power') },
    { Key: 'DC Power', KeyText: translateObject('DC Power') },
    { Key: 'Flow Configuration', KeyText: translateObject('Flow Configuration') },
    { Key: 'Feed TDS', KeyText: translateObject('Feed TDS') },
    { Key: 'Feed pH', KeyText: translateObject('Feed pH') },
    { Key: 'Product Resistivity', KeyText: translateObject('Product Resistivity') },
    { Key: 'Product pH', KeyText: translateObject('Product pH') },
    { Key: 'Concentrate TDS', KeyText: translateObject('Concentrate TDS') },
    { Key: 'Concentrate pH', KeyText: translateObject('Concentrate pH') },
    { Key: 'Electrode Bleed TDS', KeyText: translateObject('Electrode Bleed TDS') },
    { Key: 'Electrode Bleed pH', KeyText: translateObject('Electrode Bleed pH') },
  ];
  const EDI_Params1 = [
    {
      key: 'Electrode Gas Generation',
      keyText: translateObject('Electrode Gas Generation'),
      subkey: [
        {
          key: 'H2',
          keyText: 'H2',
          keyValue: 'H2',
        },
        {
          key: 'Cl2',
          keyText: 'Cl2',
          keyValue: 'Cl2',
        },
        {
          key: '-',
          keyText: '-',
          keyValue: '-',
        },
      ],
    },
    {
      key: 'Blower/Ventilation Sizing for H2',
      keyText: translateObject('Blower/Ventilation Sizing for H2'),
      subkey: [
        {
          key: 'Explosion limit of H2 in Air',
          keyText: translateObject('Explosion limit of H2 in Air'),
          keyValue: 'Explosion limit of H2 in Air',
        },
        {
          key: 'Design Safety Factor',
          keyText: translateObject('Design Safety Factor'),
          keyValue: 'Design Safety Factor',
        },
        {
          key: 'Ventilation Blower/Fan',
          keyText: translateObject('Ventilation Blower/Fan'),
          keyValue: 'Ventilation Blower/Fan',
        },
        {
          key: 'Size',
          keyText: translateObject('Size'),
          keyValue: 'Size',
        },
      ],
    },
    {
      key: 'Blower/Ventilation Sizing for Cl2',
      keyText: translateObject('Blower/Ventilation Sizing for Cl2'),
      subkey: [
        {
          key: 'Explosion limit of Cl2 in Air',
          keyText: translateObject('Explosion limit of Cl2 in Air'),
          keyValue: 'Exposure Limit of Cl2 in Air',
        },
        {
          key: 'Design Safety Factor',
          keyText: translateObject('Design Safety Factor'),
          keyValue: 'Design Safety Factor',
        },
        {
          key: 'Ventilation Blower/Fan',
          keyText: translateObject('Ventilation Blower/Fan'),
          keyValue: 'Ventilation Blower/Fan',
        },
        {
          key: 'Size',
          keyText: translateObject('Size'),
          keyValue: 'Size',
        },
      ],
    },
  ];
  const RO_units_params = [
    { Key: 'Upstream unit', KeyText: translateObject('Upstream unit') },
    { Key: 'Downstream unit', KeyText: translateObject('Downstream unit') },
    { Key: 'Feed Flow', KeyText: translateObject('Feed Flow') },
    { Key: 'Product Flow', KeyText: translateObject('Permeate Flow') },
    { Key: 'Downstream Flow', KeyText: translateObject('Downstream Permeate Flow') },
    { Key: 'Upstream Flow', KeyText: translateObject('Split Upstream Flow') },
    { Key: 'Concentrate Flow', KeyText: translateObject('Concentrate Flow') },
    { Key: 'RO Unit Recovery', KeyText: translateObject('RO/NF Unit Recovery') },
    { Key: 'Average Flux', KeyText: translateObject('Average Flux') },
    { Key: 'Breakdown by Stage', KeyText: translateObject('Breakdown by Stage') },
    { Key: 'Total Membrane Area', KeyText: translateObject('Total Membrane Area') },
    { Key: 'Feed Temperature', KeyText: translateObject('Feed Temperature') },
    { Key: 'Feed Pressure', KeyText: translateObject('Feed Pressure') },
    { Key: 'Interstage Pressure', KeyText: translateObject('Interstage Pressure') },
    { Key: 'Product Pressure *', KeyText: translateObject('Product Pressure *') },
    { Key: 'Feed TDS', KeyText: translateObject('Feed TDS') },
    { Key: 'Feed pH', KeyText: translateObject('Feed pH') },
    { Key: 'Permeate TDS', KeyText: translateObject('Permeate TDS') },
    { Key: 'Permeate pH', KeyText: translateObject('Permeate pH') },
    { Key: 'Concentrate TDS', KeyText: translateObject('Concentrate TDS') },
    { Key: 'Concentrate pH', KeyText: translateObject('Concentrate pH') },
  ];
  const EDI_Params3 = [
    {
      key: 'Input Parameters',
      keyText: translateObject('Input Parameters'),
      subKey: [
        { key: 'Stack Model', keyVal: translateObject('Stack Model') },
        { key: 'Target Resistivity', keyVal: translateObject('Target Resistivity') },
        { key: 'Product Flow', keyVal: translateObject('System Product Flow Rate') },
        { key: 'Flow per stack', keyVal: translateObject('Product Flow Rate per Stack') },
        { key: 'Target Silica guarantee', keyVal: translateObject('Target Silica guarantee') },
        { key: 'Rectifier efficiency', keyVal: translateObject('Rectifier efficiency') },
        { key: 'Rectifier DC output', keyVal: translateObject('Rectifier DC output') },
        { key: 'Feed Pressure', keyVal: translateObject('Feed Pressure') },
        { key: 'Upstream Interconnecting Piping Pressure Loss', keyVal: translateObject('Upstream Interconnecting Piping Pressure Loss') },
        { key: 'Flow Configuration', keyVal: translateObject('Flow Configuration') },
      ],
    },
    {
      key: 'Feedwater Parameters',
      keyText: translateObject('Feedwater Parameters'),
      subKey: [
        { key: 'Temperature', keyVal: translateObject('Temperature') },
        { key: 'TEA', keyVal: translateObject('TEA') },
        { key: 'TEC', keyVal: translateObject('TEC') },
        { key: 'pH', keyVal: translateObject('pH') },
        { key: 'Alkalinity', keyVal: translateObject('Alkalinity') },
        { key: 'Hardness', keyVal: translateObject('Hardness') },
        { key: 'Fe++', keyVal: translateObject('Fe++') },
        { key: 'Mn++', keyVal: translateObject('Mn++') },
        { key: 'B', keyVal: translateObject('B') },
        { key: 'H2S', keyVal: translateObject('H2S') },
        { key: 'Silica', keyVal: translateObject('Silica') },
        { key: 'Cond', keyVal: translateObject('Conductvity') },
      ],
    },
    {
      key: 'Calculated Output Parameters',
      keyText: translateObject('Calculated Output Parameters'),
      subKey: [
        // { key: 'Product Flow Rate', keyVal: 'Product Flow Rate' },
        { key: 'Product Resistivity', keyVal: translateObject('Product Resistivity') },
        {
          key: 'Product Silica guarantee level',
          keyVal: translateObject('Product Silica guarantee level'),
        },
        { key: 'Predicted Silica product', keyVal: translateObject('Predicted Product Silica Level') },
        {
          key: 'Product Sodium guarantee level',
          keyVal: translateObject('Predicted Product Sodium level'),
        },
        {
          key: 'Product Chloride guarantee level',
          keyVal: translateObject('Predicted Product Chloride level'),
        },
        {
          key: 'Product Sulfate guarantee level',
          keyVal: translateObject('Predicted Product Sulfate level'),
        },
        {
          key: 'Maximum Allowable Recovery',
          keyVal: translateObject('Maximum Allowable Recovery'),
        },
        // {
        //   key: 'Selected Recovery',
        //   keyVal: translateObject('Selected Recovery'),
        // },
        { key: 'Number of E-Cell EDI Stack', keyVal: translateObject('No. of E-Cell EDI Stacks') },
        { key: 'Current', keyVal: translateObject('Current') },
        { key: 'Voltage', keyVal: translateObject('Voltage') },
        { key: 'E-Factor', keyVal: translateObject('E-Factor') },
        { key: 'DC power', keyVal: translateObject('DC power') },
        { key: 'AC power consumption', keyVal: translateObject('AC power consumption') },
        { key: 'AC energy', keyVal: translateObject('AC energy') },
        // { key: 'Feed pressure', keyVal: 'Feed pressure' },
        {
          key: 'Predicted Product outlet pressure',
          keyVal: translateObject('Predicted Product outlet pressure'),
        },
        { key: 'Feed Inlet', keyVal: translateObject('Feed Inlet') },
        { key: 'Concentrate Outlet', keyVal: translateObject('Concentrate Outlet') },
        { key: 'Electrode Bleed', keyVal: translateObject('Electrode Bleed') },
      ],
    },
  ];
  const ROElements_Params = [
    {
      key: 'Flow',
      keyText: translateObject('Flow'),
      subKey: [
        { key: 'Feed', keyVal: translateObject('Feed') },
        { key: 'Permeate', keyVal: translateObject('Permeate') }
      ],
    },
    {
      key: 'Pressure',
      keyText: translateObject('Pressure'),
      subKey: [
        { key: 'Feed', keyVal: translateObject('Feed') },
        { key: 'Net Driving', keyVal: translateObject('Net Driving') },
        { key: 'Delta Pressure', keyVal: translateObject('Delta Pressure') },
        { key: 'Feed Osm. Pressure', keyVal: translateObject('Feed Osm. Pressure') }
      ],
    },
    {
      key: 'Other',
      keyText: translateObject('Other'),
      subKey: [
        { key: 'Recovery', keyVal: translateObject('Recovery') },
        { key: 'Beta (Conc. Pol.)', keyVal: translateObject('Beta (Conc. Pol.)') },
        { key: 'Flux', keyVal: translateObject('Flux') },
        { key: 'A-Value', keyVal: translateObject('A-Value') }
      ],
    }, {
      key: 'Stream Property',
      keyText: translateObject('Stream Property'),
      subKey: [
        { key: 'pH', keyVal: translateObject('pH') },
        { key: 'Alkalinity', keyVal: translateObject('Alkalinity') },
        { key: 'Conductivity at 25°C', keyVal: translateObject('Conductivity at 25°C') },
        { key: 'Hardness', keyVal: translateObject('Hardness') },
        { key: 'Density', keyVal: translateObject('Density') },
        { key: 'Ionic Strength', keyVal: translateObject('Ionic Strength') }
      ],
    }, {
      key: 'Permeate Ion Concentration',
      keyText: translateObject('Permeate Ion Concentration'),
      subKey: [{ 'key': 'Ca++', 'keyVal': 'Ca++', 'unit': 'mg/L' }, { 'key': 'Mg++', 'keyVal': 'Mg++', 'unit': 'mg/L' }, { 'key': 'Na+', 'keyVal': 'Na+', 'unit': 'mg/L' }, { 'key': 'K+', 'keyVal': 'K+', 'unit': 'mg/L' }, { 'key': 'NH4+', 'keyVal': 'NH4+', 'unit': 'mg/L' }, { 'key': 'Ba++', 'keyVal': 'Ba++', 'unit': 'mg/L' }, { 'key': 'Sr++', 'keyVal': 'Sr++', 'unit': 'mg/L' }, { 'key': 'Fe++', 'keyVal': 'Fe++', 'unit': 'mg/L' }, { 'key': 'Mn++', 'keyVal': 'Mn++', 'unit': 'mg/L' }, { 'key': 'SO4--', 'keyVal': 'SO4--', 'unit': 'mg/L' }, { 'key': 'Cl-', 'keyVal': 'Cl-', 'unit': 'mg/L' }, { 'key': 'F-', 'keyVal': 'F-', 'unit': 'mg/L' }, { 'key': 'NO3-', 'keyVal': 'NO3-', 'unit': 'mg/L' }, { 'key': 'Br-', 'keyVal': 'Br-', 'unit': 'mg/L' }, { 'key': 'PO4---', 'keyVal': 'PO4---', 'unit': 'mg/L' }, { 'key': 'B-', 'keyVal': 'B-', 'unit': 'mg/L' }, { 'key': 'SiO2', 'keyVal': 'SiO2', 'unit': 'mg/L' }, { 'key': 'H2S', 'keyVal': 'H2S', 'unit': 'mg/L' }, { 'key': 'HCO3-', 'keyVal': 'HCO3-', 'unit': 'mg/L' }, { 'key': 'CO2', 'keyVal': 'CO2', 'unit': 'mg/L' }, { 'key': 'CO3--', 'keyVal': 'CO3--', 'unit': 'mg/L' }, { 'key': 'TDS', 'keyVal': 'TDS', 'unit': 'mg/L' }],
    }, {
      key: 'Saturation Data',
      keyText: translateObject('Saturation Data'),
      subKey: [{ 'key': 'BaSO4', 'keyVal': 'BaSO4', 'unit': '%' }, { 'key': 'CaF2 ', 'keyVal': 'CaF2 ', 'unit': '%' }, { 'key': 'Mg(OH)2', 'keyVal': 'Mg(OH)2', 'unit': '%' }, { 'key': 'SiO2 ', 'keyVal': 'SiO2 ', 'unit': '%' }, { 'key': 'SrSO4 ', 'keyVal': 'SrSO4 ', 'unit': '%' }, { 'key': 'Struvite ', 'keyVal': 'Struvite ', 'unit': '%' }, { 'key': 'LSI', 'keyVal': 'LSI', 'unit': '' }, { 'key': 'SDSI', 'keyVal': 'SDSI', 'unit': '' }],
    },
  ];

  const getDocked_summary = (ro_stages_dict, ro_dict) => {
    const tables = {};
    const herder_val = [
      translateObject('Stage'),
      translateObject('Housing'),
      translateObject('Elements'),
      translateObject('Element Type'),
      `${translateObject('Flow')} (${system_units['Volume Flow']})`,
      `${translateObject('Flow')} (${system_units['Volume Flow']})`,
      `${translateObject('Flow')} (${system_units['Volume Flow']})`,
      translateObject('Recovery (%)'),
      `${translateObject('Flux')} (${system_units.Flux})`,
      `${translateObject('Pressure')} (${system_units.Pressure})`,
      `${translateObject('Pressure')} (${system_units.Pressure})`,
      `${translateObject('TDS')} (mg/L)`,
      `${translateObject('TDS')} (mg/L)`,
      translateObject('Last Element Beta')
    ];
    const herder_val1 = [
      '',
      '',
      '',
      '',
      translateObject('Feed'),
      translateObject('Conc.'),
      translateObject('Perm.'),
      '',
      '',
      translateObject('Feed'),
      translateObject('dP'),
      translateObject('Feed'),
      translateObject('Perm.'),
      ''
    ];
    // Object.keys(ro_stage_dict).map((v, ind) => {
    if (ro_summary.ro_system_dict['RO/NF Unit ID'] && ro_summary.ro_system_dict['RO/NF Unit ID'].length > 0) {
      ro_summary.ro_system_dict['RO/NF Unit ID'].map((v, ind) => {
        const row = [];
        row.push(Array(14).fill(`${v} Array Design`));
        row.push(herder_val);
        row.push(herder_val1);
        Object.values(ro_stages_dict[v].Stage).map((d, i) => {
          const staqge = i + 1;
          row.push([staqge, ...['Housing', 'Elements', 'Element Type', 'Flow', 'Conc.', 'Perm.', '% Recovery', 'Flux', 'Feed Pressure', 'Pressure dp', 'Feed TDS mg/L', 'Perm TDS mg/L', 'Last Elem Beta'].map((k) => {
            if (k === 'Element Type') {
              return ro_dict[v]['grid-data'][i].elementModel;
            }
            if (k === 'Flux' && system_units.Flux === 'm/s') {
              return Number.parseFloat(d[k]).toExponential(2);
            }
            return d[k];
          })]);
        });
        tables[ind] = row;
      });
      const { ro_system_dict, ro_stage_dict, aggregated_stream_data } = ro_summary; // Destructure ro_summary to extract ro_system_dict, ro_stage_dict, and aggregated_stream_data
      ro_system_dict['RO/NF Unit ID'].map((ele, ind) => { // Iterate through each RO/NF Unit ID in the ro_system_dict
        let aggregatedTotalData = aggregated_stream_data.filter((aggre) => { // Filter aggregated_stream_data to find the data matching the current unit ID (ele)
          return aggre.name === ele; // Return true if the name matches the current element
        });
        aggregatedTotalData = aggregatedTotalData[0]; // Extract the first element from the filtered array
        if (ele.toLocaleLowerCase().indexOf('ro') === 0) { // Check if the unit ID starts with 'ro' (case-insensitive)
          const aggregate_data_google_sheet = [];
          const concentrate_stages = Object.values(ro_stage_dict[ele].Stage).map((_, idx) => `Stage ${idx + 1}`); // Create an array of stage names like ['Stage 1', 'Stage 2', ...] based on the number of stages
          let parameterStage = [...concentrate_stages]; // Create a copy of concentrate_stages for parameter stages
          if (aggregatedTotalData.split_flow) { // Check if split flow exists in the aggregated data
            parameterStage = parameterStage.flatMap(item => { // Transform parameterStage array to split 'Stage 1' into upstream and downstream
              if (item === 'Stage 1') { // Check if the current item is 'Stage 1'
                return ['Stage 1 Upstream', 'Stage 1 Downstream']; // Return array with upstream and downstream for Stage 1
              }
              return item; // Return the item as-is for other stages
            });
          }
          aggregate_data_google_sheet.push([
            `${ele} Aggregate Stream Summary`,
            `${ele} Aggregate Stream Summary`,
            ...Array(concentrate_stages.length).fill(`${ele} Aggregate Stream Summary`),
            ...Array(parameterStage.length).fill(`${ele} Aggregate Stream Summary`),
            `${ele} Aggregate Stream Summary`
          ]); // Initialize the aggregate data array with a header row
          aggregate_data_google_sheet.push([
            'Concentrations (mg/L as ion)',
            'Concentrations (mg/L as ion)',
            ...Array(concentrate_stages.length).fill('Concentrations (mg/L as ion)'),
            ...Array(parameterStage.length).fill('Concentrations (mg/L as ion)'),
            'Concentrations (mg/L as ion)'
          ]); // Initialize the aggregate data array with a header row
          aggregate_data_google_sheet.push([
            'Parameter',
            'Feed',
            ...Array(concentrate_stages.length).fill('Concentrate'),
            ...Array(parameterStage.length).fill('Permeate'),
            'Permeate'
          ]); // Add a row with column group headers for Concentrate and Permeate
          const table2Header = [ // Create the table header row with all column names
            '', // First column for parameter names
            '', // Second column for feed values
            ...concentrate_stages, // Spread concentrate stage columns
            ...parameterStage, // Spread parameter stage columns (includes split flow if applicable)
            'Mixed' // Last column for mixed values
          ];
          aggregate_data_google_sheet.push(table2Header); // Add the header row to the aggregate data sheet
          const ro_output_data = JSON.parse(localStorage.getItem('ro_ouput_data')); // Retrieve RO output data from localStorage and parse it from JSON string
          const stream_ouput_data = JSON.parse(localStorage.getItem('stream_ouput_data')); // Retrieve stream output data from localStorage and parse it from JSON string
          const downStream = stream_ouput_data[aggregatedTotalData.product]; // Get the downstream data for the current product from stream output data
          dataArray.map((d_ele) => { // Iterate through each parameter in dataArray to create data rows
            const finalObj = [d_ele.key]; // Initialize the row array with the parameter key as the first element
            const permValue = []; // Initialize array to store permeate values for all stages
            const constValue = []; // Initialize array to store concentrate values for all stages
            ro_output_data[ele].output_user.stage.map((stage_ele, stage_ind) => { // Iterate through each stage in the RO output data for the current unit
              if (stage_ind === 0) { // Check if this is the first stage (index 0)
                const feedval = stage_ele.feed_ppm[d_ele.key1]; // Get the feed value for the current parameter from feed_ppm
                finalObj.push(feedval >= 0 ? feedval.toFixed(2) : stage_ele[d_ele.key1].toFixed(2)); // Push feed value if it's valid (>= 0), otherwise use alternative key from stage_ele
              }
              const concval = stage_ele.conc_ppm[d_ele.key1]; // Get the concentrate value for the current parameter from conc_ppm
              constValue.push(concval >= 0 ? concval.toFixed(2) : stage_ele[d_ele.key1.replace('feed', 'conc')].toFixed(2)); // Push concentrate value if valid, otherwise use alternative key with 'feed' replaced by 'conc'
              if (aggregatedTotalData.split_flow && stage_ind === 0) { // Check if split flow exists for this aggregated data
                const upstream = ro_output_data[ele].output_user.split[d_ele.key3][d_ele.key2]; // Get the upstream split flow value for the current parameter
                permValue.push(Object.prototype.toString.call(upstream) === '[object String]' ? upstream : upstream.toFixed(2)); // Add upstream value to permValue array
              }
              const permval = stage_ele.perm_ppm[d_ele.key1]; // Get the permeate value for the current parameter from perm_ppm
              permValue.push(permval >= 0 ? permval.toFixed(2) : stage_ele[d_ele.key1.replace('feed', 'perm')].toFixed(2)); // Push permeate value if valid, otherwise use alternative key with 'feed' replaced by 'perm'
            });
            finalObj.push(...constValue); // Spread and add all concentrate values to the final row object
            finalObj.push(...permValue); // Spread and add all permeate values to the final row object
            const getValue = downStream[d_ele.key3][d_ele.key2];
            finalObj.push(Object.prototype.toString.call(getValue) === '[object String]' ? getValue : getValue.toFixed(2)); // Add the mixed/downstream value from stream output data to the final row
            aggregate_data_google_sheet.push(finalObj); // Add the complete row to the aggregate data sheet
            return finalObj; // Return the complete row array
          });
          const lastIndex = Math.max(...Object.keys(tables).map(Number)); // Find the last index in the tables object by getting the maximum numeric key
          tables[lastIndex + 1] = aggregate_data_google_sheet; // Add the new aggregate data sheet to tables object with the next available index
        }
      });
    }
    return tables;
  };
  const getDetailDesign = (ro_dict) => {
    const herder_val = [
      '',
      '',
      '',
      ' ',
      '',
      `Pressure Change (${system_units.Pressure})`,
      '',
      '',
      '',
      '',
    ];
    let herder_val1 = [
      translateObject('Stage'),
      translateObject('Housing'),
      translateObject('Elements'),
      translateObject('Element Type'),
      ro_hp.abFactor === 0 ? translateObject('Element Age   (yr) ') : '',
      translateObject('Boost'),
      translateObject('Loss'),
      `Permeate P  (${system_units.Pressure})`,
      ro_hp.abFactor === 0 ? translateObject('A-Value ACP') : translateObject('A-Factor'),
      ro_hp.abFactor === 0 ? translateObject('B-Value ACP') : translateObject('B-Factor')
    ];
    herder_val1 = herder_val1.filter((ele) => ele);
    const tables = [];
    Object.keys(ro_dict).map((v) => {
      // ro_elem_summary['RO/NF Unit ID'].map((v) => {
      const row = [];
      row.push([v, '', '', ' ', '', '', '', '', '', '']);
      if (ro_dict[v].roMachine && Object.prototype.toString.call(ro_dict[v].roMachine) === '[object Object]') {
        row.push([`RO Machine Configuration - ${ro_dict[v].roMachine.ROMachineModel}`, '', '', ' ', '', '', '', '', '', '']);
      }
      row.push(herder_val);
      row.push(herder_val1);
      ro_dict[v]['grid-data'].map((d) => {
        if (d.pressureVessels !== 0) {
          let arr = [translateObject('stage'), translateObject('pressureVessels'), translateObject('elementsperVessel'), translateObject('elementModel'), translateObject('interStageBoostPressure'), translateObject('interStagePressureLoss'), translateObject('permeatePressure'), translateObject('fluxAnnual'), translateObject('saltPassageAnnual')];
          if (ro_hp.abFactor === 0) {
            arr = [translateObject('stage'), translateObject('pressureVessels'), translateObject('elementsperVessel'), translateObject('elementModel'), translateObject('elementAge'), translateObject('interStageBoostPressure'), translateObject('interStagePressureLoss'), translateObject('permeatePressure'), translateObject('fluxAnnual'), translateObject('saltPassageAnnual')];
          }
          row.push(arr.map((k) => d[k]));
        }
      });
      tables.push(row);
    });
    return tables;
  };
  function getROElements(jsonData, ROElements_Params) {
    const csvData = [];
    const heading1 = [translateObject('Category'), translateObject('Parameter')];
    const heading2 = [translateObject('Category'), translateObject('Parameter'), translateObject('Stage No.')];
    const heading3 = [translateObject('Category'), translateObject('Parameter'), translateObject('Element Pos.')];
    if (jsonData['RO/NF Unit ID'] && jsonData['RO/NF Unit ID'].length > 0) {
      jsonData['RO/NF Unit ID'].forEach(e => {
        Object.keys(jsonData[e]).forEach((d) => {
          const stageNum = Object.keys(jsonData[e][d]);
          stageNum.map((stageEle, ind) => {
            stageNum[ind] = Number(stageEle) + 1;
          });
          heading3.push(...stageNum);
          heading2.push(stageNum);
          heading2.push(d);
          heading1.push(d);
          heading1.push(stageNum);
        });
        heading1.push(e);
      });
    }
    const heading2Array = [].concat(...heading2.map(item =>
      Array.isArray(item) ? new Array(item.length - 1).fill('') : item
    ));
    const heading1Array = [].concat(...heading1.map(item => {
      if (Array.isArray(item)) {
        return new Array(item.length - 1).fill('');
      } if (typeof item === 'string' && item.startsWith('Stage')) {
        if (item === 'Stage 1') {
          return '';
        } return [];
      }
      return item;

    }));
    csvData.push(heading1Array);
    csvData.push(heading2Array);
    csvData.push(heading3);
    ROElements_Params.forEach(param => {
      const category = param.key;
      const subKeys = param.subKey;
      subKeys.forEach(subKey => {
        const row = [];
        row.push(param.keyText);
        row.push(subKey.keyVal === 'B-' ? 'B' : subKey.keyVal);
        row.push(jsonData.units[category][subKey.key]);
        if (jsonData['RO/NF Unit ID'] && jsonData['RO/NF Unit ID'].length > 0) {
          jsonData['RO/NF Unit ID'].map((v) => {
            return Object.keys(jsonData[v]).map((d) => {
              return Object.keys(jsonData[v][d]).map((k) => {
                if (subKey.key === 'Flux' && system_units.Flux === 'm/s' && Object.prototype.toString.call(jsonData[v][d][k].Category[category][subKey.key] === '[object Number]')) {
                  return row.push(Number.parseFloat(jsonData[v][d][k].Category[category][subKey.key]).toExponential(2));
                }
                if (Object.prototype.toString.call(jsonData[v][d][k].Category[category][subKey.key] === '[object Number]')) {
                  return row.push(Number(jsonData[v][d][k].Category[category][subKey.key]).toFixed(2));
                }
                return row.push(jsonData[v][d][k].Category[category][subKey.key]);
              });
            });
          });
        }
        csvData.push(row);
      });
    });
    return csvData;
  };
  function jsonToCSV() {
    // const keys = Object.keys(json);
    // const headers = Object.keys(json[keys[0]][Object.keys(json[keys[0]])[0]]);
    const csvRows = [];
    clro_elem_summary['CLRO Unit ID'].map((ele) => {
      const clroElements = clro_elem_summary[ele].Elements;
      const keys = Object.keys(clroElements);
      const headers = Object.keys(Object.values(clroElements[keys[0]])[0]);
      // Add headers
      csvRows.push([ele]);
      csvRows.push([translateObject('Cycle'), translateObject('Element'), translateObject('Recovery (%)'), `${translateObject('Feed Flow')} (${system_units['Volume Flow']})`, `${translateObject('Feed Press')} (${system_units.Pressure})`, translateObject('Feed TDS (mg/L)'), `${translateObject('Conc Flow')} (${system_units['Volume Flow']})`, `${translateObject('Perm Flow')} (${system_units['Volume Flow']})`, translateObject('Perm TDS (mg/L)')]);
      // Add data rows
      keys.forEach(key => {
        const section = clroElements[key];
        const sectionKeys = Object.keys(section);
        sectionKeys.forEach(sectionKey => {
          const row = section[sectionKey];
          const rowValues = headers.map(header => row[header]);
          csvRows.push([key, sectionKey, ...rowValues]);
        });
      });
      csvRows.push(['', '', '', '', '', '', '', '', '']);
      csvRows.push(['', '', '', '', '', '', '', '', '']);
    });
    return csvRows;
  }
  function convertToCSV() {
    const csvData = [];
    // const topLevelKeys = Object.keys(jsonData);
    clro_elem_summary['CLRO Unit ID'].map((ele) => {
      const clroElements = clro_elem_summary[ele].Concentrations;
      const topLevelKeys = Object.keys(clroElements);
      const allKeys = new Set();
      const h1 = [translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)'), translateObject('Concentrations (mg/L as ion)')];
      const h2 = ['', '', translateObject('Concentrate'), translateObject('Concentrate'), translateObject('Concentrate'), translateObject('Permeate'), translateObject('Permeate'), translateObject('Permeate')];
      const h3 = ['', translateObject('Feed'), translateObject('Conc CC1'), translateObject('Conc CCFinal'), translateObject('Conc Total'), translateObject('Perm CC1'), translateObject('Perm CCFinal'), translateObject('Perm Total')];
      csvData.push([ele]);
      csvData.push(h1);
      csvData.push(h2);
      csvData.push(h3);
      // Extract all unique keys from nested objects
      topLevelKeys.forEach(topLevelKey => {
        const nestedObjects = Object.values(clroElements[topLevelKey]);
        nestedObjects.forEach(nestedObject => {
          Object.keys(nestedObject).forEach(key => allKeys.add(key));
        });
      });

      // Create rows for each key
      allKeys.forEach(key => {
        const row = [key === 'B-' ? 'B' : key];
        topLevelKeys.forEach(topLevelKey => {
          const nestedObjects = Object.values(clroElements[topLevelKey]);
          nestedObjects.forEach(nestedObject => {
            row.push(nestedObject[key] || '0.0');
          });
        });
        csvData.push(row);
      });
      csvData.push(['', '', '', '', '', '', '', '', '']);
      csvData.push(['', '', '', '', '', '', '', '', '']);
    });
    return csvData;
  }
  function JSONToCSVConvertor(jsonData, unitsids, edi_params) {
    try {
      const { design_summary, system_summary } = jsonData;
      const unitIds = Object.values(design_summary[unitsids]);
      const csvData = [[translateObject('Category'), translateObject('Parameter'), translateObject('Units'), ...unitIds]];
      edi_params.forEach(param => {
        const category = param.key;
        const subKeys = param.subKey;
        subKeys.forEach(subKey => {
          const row = [];
          row.push(param.keyText);
          row.push(subKey.keyVal);
          row.push(design_summary.units[category][subKey.key]);
          if (subKey.key === 'Number of E-Cell EDI Stack') {
            row.push(...unitIds.map((v) => appendNumberText2(system_summary[v][subKey.key].toFixed(0))));
          } else {
            row.push(...unitIds.map((v) => {
              if (design_summary[v].Parameter && design_summary[v].Parameter[category] && design_summary[v].Parameter[category][v] && design_summary[v].Parameter[category][v][subKey.key]) {
                return appendNumberText2(design_summary[v].Parameter[category][v][subKey.key]);
              }
              return '-';
            }));
          }
          csvData.push(row);
        });
      });
      return csvData;
    } catch (error) {
      console.log(error);
    }
  };
  const renderTextWithSub = (value) => {
    if (value === null || value === undefined) return null;
    const text = String(value);
    if (!text) return null;

    // CSV export expects plain strings, so normalize any sub tags to plain text.
    return text
      .replace(/<sub>(.*?)<\/sub>/gi, '$1')
      .replace(/<\/?[^>]+>/g, '')
      .trim();
  };
  function generateTableData(data, parameters, unitsids, headers) {
    const tableData = [];
    let unitIds;
    // Create header row
    if (headers === 'Chemical_dose1') {
      unitIds = Object.values(data[unitsids]);
      const headerRow = ['Chemical Dosing Unit ID', '', ...unitIds];
      tableData.push(headerRow);
    } else if (headers === 'Chemical_dose2') {
      unitIds = Object.keys(data);
      const index = unitIds.indexOf('units');
      unitIds.splice(index, 1);
      const headerRow = ['Chemical Type', '', ...unitIds];
      tableData.push(headerRow);
    } else {
      unitIds = Object.values(data[unitsids]);
      const headerRow = [unitsids, '', ...unitIds];
      tableData.push(headerRow);
    }
    if (headers === 'Mixer-Splitter') {
      parameters.forEach(param => {
        if (param.KeyText === 'Inlet Stream ID' || param.KeyText === 'Outlet Stream ID') {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => JSON.stringify(data[id][param.Key]).replaceAll('[', '').replaceAll(']', ''))];
          tableData.push(row);
        } else if (param.KeyText === 'Split Ratios' || param.KeyText === 'Mix Ratios') {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => data[id][param.Key] ? data[id][param.Key].replaceAll('Na', 'NA') : '')];
          tableData.push(row);
        } else {
          const row = [param.KeyText, data.units ? data.units[param.Key] : '-', ...unitIds.map(id => { return appendNumberText(data[id][param.Key]); })];
          tableData.push(row);
        }
      });
    } else if (headers === 'RounitID') {
      parameters.forEach(param => {
        if ((param.KeyText === 'Average Flux' && data.units[param.Key] === 'm/s') || param.KeyText === 'Breakdown by Stage' || param.KeyText === 'Interstage Pressure') {
          const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
            if (param.KeyText === 'Breakdown by Stage' || param.KeyText === 'Interstage Pressure') {
              let split_array = data[id][param.KeyText].split(',').map((unitops) => {
                if (unitops.trim()) {
                  if (data.units[param.Key] === 'm/s')
                    return Number(unitops).toExponential(2);
                  return Number(unitops).toFixed(2);
                }
                return '';
              });
              split_array = split_array.filter((ele) => ele);
              return split_array.join(', ');
            }
            return (data[id][param.Key]);
          })];
          tableData.push(row);
        }
        // added by chandrashekhar when `Downstream Permeate Flow', 'Split Upstream Flow' not exits in paylod (!ro_system_dict.units[keys.key]) check Downstream Permeate Flow exits or not START 8-May-20225
        else if (['Downstream Permeate Flow', 'Split Upstream Flow'].indexOf(param.KeyText) >= 0) {
          if (data.units[param.Key]) {
            const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
              return appendNumberText(data[id][param.Key]);
            })];
            tableData.push(row);
          }
        }
        // added by chandrashekhar when `Downstream Permeate Flow', 'Split Upstream Flow' not exits in paylod (!ro_system_dict.units[keys.key]) check Downstream Permeate Flow exits or not END 8-May-20225
        else {
          const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
            return appendNumberText(data[id][param.Key]);
          })];
          tableData.push(row);
        }
      });
    } else if (headers === 'EDI Ventil summary') {
      parameters.forEach(param => {
        tableData.push([param.keyText]);
        param.subkey.forEach(subParam => {
          const row = [subParam.keyText, data.units[param.key][subParam.key], ...unitIds.map(id => {
            return appendNumberText(data[id][param.key][subParam.key]);
          })];
          tableData.push(row);
        });
      });
      tableData.push(['']);
      // tableData.push(['The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.) A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen. Ensure ventilation maintains the hydrogen gas levels below 4%.']);
      tableData.push([translateObject('The Electrode stream must be vented as it contains small quantities of hydrogen, oxygen and possibly chlorine gas (if there is chloride ion in the Electrode stream.)')]);
      tableData.push([translateObject('A 2:1 mixture of hydrogen and oxygen gas is produced at a maximum rate of 11.4 ml/amp/minute/stack (dry gas at 25 °C, 1.0 bar), consisting of 7.6 ml of hydrogen and 3.8 ml of oxygen.')]);
      tableData.push([translateObject('Ensure ventilation maintains the hydrogen gas levels below 4%.')]);
    } else if (headers === 'Chemical_dose1' || headers === 'Chemical_dose2') {
      parameters.forEach(param => {
        const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
          if (param.Key === 'Metered Flow Rate' || param.Key === 'Avg Cons.As Metered' || param.Key === 'Avg Cons.As Supplied' || param.Key === 'Avg Cons.As Supplied with SF' || param.Key === 'Tot.Cons As Supplied' || param.Key === 'Tot.Cons As Supplied with SF' || param.Key === 'Tot.Cons Mass Flow Rate') {
            return appendNumberText(data[id][param.Key], 4);
          }
          if(param.Key === 'Chemical' || param.Key === 'Supplied Form') {
            return renderTextWithSub(translateObject(data[id][param.Key]));
          }
          return appendNumberText(data[id][param.Key], 2);
        })];
        tableData.push(row);
      });
    } else {
      parameters.forEach(param => {
        const row = [param.KeyText, data.units[param.Key], ...unitIds.map(id => {
          if (param.Key === 'Number of E-Cell EDI Stack')
            return appendNumberText(data[id][param.Key], 0);
          return appendNumberText(data[id][param.Key]);
        })];
        tableData.push(row);
      });
    }
    // Create data rows
    return tableData;
  };
  const getFlowsheetAllValues = () => {
    const items = Object.keys(stream_output);
    let tempval = true;
    const { temp } = stream_output[items[0]];
    Object.values(stream_output).forEach(ele => {
      if (Number(ele.temp).toFixed(2) !== Number(temp).toFixed(2)) {
        tempval = false;
      }
    });
    const data = [
      [translateObject('Stream Id'), translateObject('Stream Name'), `${translateObject('Flow')}, ${system_units['Volume Flow']}`, `${translateObject('Temperature')}, ${system_units.Temperature}`, `${translateObject('Pressure')}, ${system_units.Pressure}`, translateObject('TDS, mg/l'), translateObject('Alkalinity, ppm CaCO3'), translateObject('Hardness, ppm as CaCO3'), translateObject('pH'), translateObject('Conductivity at 25°C, µS/cm')]
    ];
    if (tempval) {
      data[0].splice(3, 1);
    }
    items.map((ele) => {
      if (stream_output[ele]) {
        const { sat_indices, prop_dict } = stream_output[ele];
        const allVal = [
          ele,
          stream_output[ele].label ? stream_output[ele].label : '',
          Object.prototype.toString.call(prop_dict.flow) === '[object Number]' ? prop_dict.flow.toFixed(2) : prop_dict.flow,
          Object.prototype.toString.call(prop_dict.temp) === '[object Number]' ? prop_dict.temp.toFixed(2) : prop_dict.temp,
          Object.prototype.toString.call(prop_dict.press) === '[object Number]' ? prop_dict.press.toFixed(2) : prop_dict.press,
          Object.prototype.toString.call(prop_dict.tds) === '[object Number]' ? prop_dict.tds.toFixed(2) : prop_dict.tds,
          Object.prototype.toString.call(prop_dict.malk) === '[object Number]' ? prop_dict.malk.toFixed(2) : prop_dict.malk,
          Object.prototype.toString.call(stream_output[ele].hardness) === '[object Number]' ? stream_output[ele].hardness.toFixed(2) : stream_output[ele].hardness,
          Object.prototype.toString.call(prop_dict.ph) === '[object Number]' ? prop_dict.ph.toFixed(2) : prop_dict.ph,
          Object.prototype.toString.call(sat_indices.conductivity) === '[object Number]' ? sat_indices.conductivity.toFixed(2) : sat_indices.conductivity
        ];
        if (tempval) {
          allVal.splice(3, 1);
        }
        return data.push(allVal);
      }
    });
    return data;
  };
  function CLROjsonToCSV() {
    const table = [];

    function addRow(parameter, unit, value) {
      table.push([parameter, unit, value]);
    }
    Object.keys(clro_overview).map((ele) => {
      const clroEle = clro_overview[ele];
      table.push([ele]);
      addRow(translateObject('Parameters'), translateObject('Units'), translateObject('Values'));
      // DSSRO mode
      addRow(translateObject('DSSRO mode'), '', clroEle['DSSRO mode']);

      // PV
      addRow(translateObject('Elements per PV'), clroEle.units.PV, clroEle.PV['Elements per PV']);
      addRow(translateObject('Spacers per PV'), clroEle.units.PV, clroEle.PV['Spacers per PV']);
      addRow(translateObject('Length of PV'), clroEle.units.PV, clroEle.PV['Length of PV']);

      // Recovery
      addRow(translateObject('CL Recovery'), clroEle.units.Recovery, clroEle.Recovery['CL Recovery'].toFixed(2));
      addRow(translateObject('BP Recovery'), clroEle.units.Recovery, clroEle.Recovery['BP Recovery'].toFixed(2));

      // Flow
      addRow(translateObject('CL Concentrate Flow'), clroEle.units.Flow, clroEle.Flow['CL Concentrate Flow'].toFixed(2));
      addRow(translateObject('BP Concentrate Flow'), clroEle.units.Flow, clroEle.Flow['BP Concentrate Flow'].toFixed(2));
      addRow(translateObject('CL Net Feed Flow'), clroEle.units.Flow, clroEle.Flow['CL Net Feed Flow'].toFixed(2));
      addRow(translateObject('BP Feed Flow'), clroEle.units.Flow, clroEle.Flow['BP Feed Flow'].toFixed(2));
      addRow(translateObject('CL Permeate Flow'), clroEle.units.Flow, clroEle.Flow['CL Permeate Flow'].toFixed(2));

      // Total Circuits
      // addRow('Total Circuits', '', clroEle['Total Circuits']);
      addRow(translateObject('Total Circuits'), '', clroEle.Total['Total Circuits']);
      addRow(translateObject('# of Turns'), '', clroEle.Total['# of Turns']);

      // Duration
      addRow(translateObject('BP Sequence Duration'), clroEle.units.Duration, clroEle.Duration['BP Sequence Duration'].toFixed(2));
      addRow(translateObject('CL Sequence Duration'), clroEle.units.Duration, clroEle.Duration['CL Sequence Duration'].toFixed(2));
      addRow(translateObject('Complete Cycle Duration'), clroEle.units.Duration, clroEle.Duration['Complete Cycle Duration'].toFixed(2));

      // Volume
      addRow(translateObject('CL System Volume'), clroEle.units.Volume, clroEle.Volume['CL System Volume'].toFixed(2));
      addRow(translateObject('S1 Volume'), clroEle.units.Volume, clroEle.Volume['S1 Volume'].toFixed(2));
      addRow(translateObject('S2 Volume'), clroEle.units.Volume, clroEle.Volume['S2 Volume'].toFixed(2));
      addRow(translateObject('S3 Volume'), clroEle.units.Volume, clroEle.Volume['S3 Volume'].toFixed(2));
      addRow('', '', '');
      addRow('', '', '');
    });
    return table;
  };
  const StreamProperty = newData['Flowsheet Design Summary'] && getFlowsheetAllValues();
  const FSDFlowBalance = newData['Flowsheet Design Summary'] && [
    [translateObject('Parameter'), '', translateObject('Incoming'), translateObject('Outgoing')],
    ['', '', '', translateObject('Product'), translateObject('Waste')], ['Unit ID (Stream no.)', ...Object.values(coverpage_dict.flow_bal['unit id (stream no.)']).map(e => !Array.isArray(e) ? e : e.join(', '))],
    [`${translateObject('Flow')}`, ...Object.values(coverpage_dict.flow_bal.flow).map((e => !Array.isArray(e) ? e : e.flatMap(v => Number(v).toFixed(2)).join(',')))],
    [`${translateObject('Flow - Total')}`, ...Object.values(coverpage_dict.flow_bal['flow-total']).map((e => Number.isNaN(Number(e)) ? e : Number(e).toFixed(2)))],
    [`${translateObject('Overall Flow Sheet Recovery')} =  ${localStorage.getItem('systemRecovery') || 'NA'}`]
  ];
  const getAntiscalantData = () => {
    const header = [[translateObject('Dosed In'), translateObject('Antiscalant'), translateObject('Dosage in Feed'), ''], ['', '', translateObject('ppm'), translateObject('kg/day')]];
    Object.keys(argo_summary).forEach((k) => {
      header.push([...[translateObject('Dosed In'), translateObject('Antiscalant'), translateObject('Dosage ppm in Feed'), translateObject('Dosage kgperday in Feed')].map((p) => appendNumberText(argo_summary[k][p]))]);
    });
    return header;
  };
  const getMembraneSeparator = () => {
    const header1 = [
      [translateObject('Unit'), translateObject('Unit'), '', '', '', '', ''],
      [translateObject('Type'), translateObject('ID'), translateObject('Recovery'), translateObject('Feed'), translateObject('Product'), translateObject('Conc.'), translateObject('Electrode Bleed')]];
    coverpage_dict.flow_summary.Type.forEach((k) => {
      coverpage_dict.flow_summary.ID[k].map((v) => {
        header1.push([k, v, ...['Recovery', 'Feed', 'Product', 'Waste', 'Electrode'].map((p) => appendNumberText(coverpage_dict.flow_summary[p][v]))]);
      });
    });
    return header1;
  };
  const getErrorData = (errors) => {
    const val = [['Unit Op', 'Type', translateObject('Description')]];
    errors.forEach((v) => {
      v.data.forEach((d) => {
        val.push([
          v.name,
          warningMarkerData.some(marker =>
            d.toLowerCase().startsWith(marker.toLowerCase())
          ) ? 'Warning' : 'Error',
          d.split('\n')[0]
        ]);
        // val.push([v.name, d.toLowerCase().indexOf('warning') === 0 ? 'Warning' : 'Error', d.split('\n')[0]]);
      });
    });
    return val;
    // }
  };
  if (newData['Mixer-Splitter Unit Summary']) {
    if (!mixer_summary.units)
      addUnitsInMixerSplitter();
  }
  const MembraneSeparator = newData['Flowsheet Design Summary'] && getMembraneSeparator();

  const StripperData = newData['Stripper Unit Summary'] && generateTableData(stripper_summary, stripper_values_keys, 'Stripper Unit ID');
  const Chemical_DosingData1 = newData['Chemical Dosing Unit Summary'] && generateTableData(chem_dose_summary, chemical_dose_para, 'Chemical Dosing Unit ID', 'Chemical_dose1');
  const Chemical_DosingData2 = newData['Chemical Dosing Unit Summary'] && generateTableData(chem_dose_summary.agg_chem_dose_dict, chemical_dose_supplied_para, 'Chemical Dosing Unit ID', 'Chemical_dose2');
  const ERD_Data = newData['ERD Unit Summary (WIP)'] && generateTableData(erd_summary, ERD_key_value, 'ERD Unit ID');
  const EDI_Data = newData['EDI Unit System-Level Summary'] && generateTableData(edi_summary.system_summary, EDI_Params, 'EDI Unit ID', 'ediDocsummary');
  const RO_unit_Data = newData['RO/NF Unit System-Level Summary'] && generateTableData(ro_summary.ro_system_dict, RO_units_params, 'RO/NF Unit ID', 'RounitID');
  if (newData['EDI Unit System-Level Summary']) {
    edi_summary.ventil_summary['EDI Unit ID'] = edi_summary.system_summary['EDI Unit ID'];
    edi_summary.design_summary['EDI Unit ID'] = edi_summary.system_summary['EDI Unit ID'];
  }
  const EDI_design_summary_Data = newData['EDI Unit System-Level Summary'] && JSONToCSVConvertor({ design_summary: edi_summary.design_summary, system_summary: edi_summary.system_summary }, 'EDI Unit ID', EDI_Params3);
  const EDI_Data1 = newData['EDI Unit System-Level Summary'] && generateTableData(edi_summary.ventil_summary, EDI_Params1, 'EDI Unit ID', 'EDI Ventil summary');
  const CLROOverviewcsvData = newData['DSSRO Section Summary'] && CLROjsonToCSV(clro_overview[clro_elem_summary['CLRO Unit ID'][0]]);
  const csvData = newData['DSSRO Section Summary'] && jsonToCSV(clro_elem_summary[clro_elem_summary['CLRO Unit ID'][0]].Elements);
  const Mixer_Splitter_Data = newData['Mixer-Splitter Unit Summary'] && generateTableData(mixer_summary, Mixer_Splitter_Params, 'Mixer-Splitter Unit ID', 'Mixer-Splitter');
  const CF_Params_Data = newData['CF Unit Summary'] && generateTableData(cf_summary, CF_Params, 'CF Unit ID');
  const Pump_Data = newData['Pump Unit Summary'] && generateTableData(pump_summary, Pumps_Params, 'Pump Unit ID');
  const csvData1 = newData['DSSRO Section Summary'] && convertToCSV(clro_elem_summary[clro_elem_summary['CLRO Unit ID'][0]].Concentrations);
  const RO_elements_Data = newData['Detailed RO/NF Element-Level Data'] && getROElements(ro_elem_summary, ROElements_Params);
  const RO_Design_details = newData['RO/NF Unit System-Level Summary'] && getDetailDesign(ro_hp.ro_dict);
  const RO_DockedSummary = newData['RO/NF Unit Stage-Level Summary'] && getDocked_summary(ro_summary.ro_stage_dict, ro_hp.ro_dict);
  const ARGO_Summary = newData['Antiscalant Dosage Summary'] && getAntiscalantData();
  const ro_details = newData['RO/NF Unit System-Level Summary'] && [RO_unit_Data, ...RO_Design_details];
  const error_data = newData.Notifications && getErrorData(errors);
  const GoogleSheetsData = [
    { label: 'Flowsheet Design Summary', data: { 'StreamProperty': StreamProperty }, 'Flowsheet Design Summary': newData['Flowsheet Design Summary'], headerRowCount: 1 },
    { label: 'Feed-Product-Waste Summary', data: feed_Preductwaste_Data, 'Feed-Product-Waste Summary': newData['Feed-Product-Waste Summary'], headerRowCount: 1 },
    { label: 'Flowsheet Diagram', data: [['Flowsheet Diagram', ''], []], 'Flowsheet Diagram': true },
    { label: 'RO/NF Unit System-Level Summary', data: { ...ro_details }, 'RO/NF Unit System-Level Summary': newData['RO/NF Unit System-Level Summary'], headerRowCount: [1, 3, 3, 3] },
    { label: 'RO/NF Unit Stage-Level Summary', data: RO_DockedSummary, 'RO/NF Unit Stage-Level Summary': newData['RO/NF Unit Stage-Level Summary'], headerRowCount: [3, 3, 3, 3] },
    { label: 'DSSRO Section Summary', data: { 'DSSRO Overview': CLROOverviewcsvData, 'DSSRO Flow Summary (Element Level)': csvData, 'DSSRO Stream Composition': csvData1 }, 'DSSRO Section Summary': newData['DSSRO Section Summary'], headerRowCount: [2, 2, 4] },
    { label: 'DSSRO Schematic Diagram', data: [['Diagram', ''], []], 'DSSRO Schematic Diagram': newData['DSSRO Section Summary'] },
    { label: 'EDI Unit System-Level Summary', data: { 'Docked Summary': EDI_Data, 'Ventilation Sizing': EDI_Data1, 'EDI Design Parameters': EDI_design_summary_Data }, 'EDI Unit System-Level Summary': newData['EDI Unit System-Level Summary'], headerRowCount: [1, 1, 1, 1] },
    { label: 'EDI Schematic Diagram', data: [['Diagram', ''], []], 'EDI Schematic Diagram': newData['EDI Unit System-Level Summary'] },
    { label: 'Chemical Dosing Unit Summary', data: { 'Docked Summary': Chemical_DosingData1, 'Supplied Form': Chemical_DosingData2 }, 'Chemical Dosing Unit Summary': newData['Chemical Dosing Unit Summary'] },
    { label: 'Antiscalant Dosage Summary', data: ARGO_Summary, 'Antiscalant Dosage Summary': newData['Antiscalant Dosage Summary'], headerRowCount: 2 },
    { label: 'CF Unit Summary', data: CF_Params_Data, 'CF Unit Summary': newData['CF Unit Summary'] },
    { label: 'ERD Unit Summary (WIP)', data: ERD_Data, 'ERD Unit Summary (WIP)': newData['ERD Unit Summary (WIP)'] },
    { label: 'Pump Unit Summary', data: Pump_Data, 'Pump Unit Summary': newData['Pump Unit Summary'] },
    { label: 'Stripper Unit Summary', data: StripperData, 'Stripper Unit Summary': newData['Stripper Unit Summary'] },
    { label: 'Mixer-Splitter Unit Summary', data: Mixer_Splitter_Data, 'Mixer-Splitter Unit Summary': newData['Mixer-Splitter Unit Summary'] },
    { label: 'Detailed RO/NF Element-Level Data', data: RO_elements_Data, 'Detailed RO/NF Element-Level Data': newData['Detailed RO/NF Element-Level Data'], headerRowCount: 3 },
    { label: 'Detailed Stream Data', data: SteamData, 'Detailed Stream Data': newData['Detailed Stream Data'] },
    { label: 'DSSRO Loop Summary', data: { 'DSSRO_Permeate_Stream': DSSRO_Permeate_Stream, 'DSSRO_Concentrate_Stream': DSSRO_Concentrate_Stream }, 'DSSRO Loop Summary': newData['DSSRO Loop Summary'] },
    { label: 'Notifications', data: error_data, 'Notifications': newData.Notifications },
  ];
  return GoogleSheetsData;
};
export default jsontocsvConvertion;
